export * from './ScmFAQs';
export * from './ScmFAQs.types';
